import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavTabs"] */ "/vercel/path0/src/components/compass/NavTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettingsLink"] */ "/vercel/path0/src/components/layout/cookie-settings-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteNav"] */ "/vercel/path0/src/components/layout/site-nav.tsx");
